import { CREDIT_STATUS, INCOMING_TYPE } from './enums'

export const defaultContactForm = process.env.NODE_ENV === 'development' ? {
  name: 'Test Test Test',
  phone: '1234567890',
  zipCode: '12345',
  email: 'test@test.com',
  message: 'Test',
} : {
  name: '',
  phone: '',
  zipCode: '',
  email: '',
  message: '',
}

export const defaultFinancingForm = process.env.NODE_ENV === 'development' ? {
  name: 'Test Test Test',
  phone: '1234567890',
  zipCode: '12345',
  email: 'test@test.com',
  incomingAmount: '10000',
  incomingType: INCOMING_TYPE.ACCOUNT_STATEMENTS,
  creditStatus: CREDIT_STATUS.BAD,
} : {
  name: '',
  phone: '',
  zipCode: '',
  email: '',
  incomingAmount: '',
  incomingType: '',
  creditStatus: '',
}

export const defaultSellYourCarForm = process.env.NODE_ENV === 'development' ? {
  name: 'Sell Your Car Test',
  email: 'test@sell-your-car.com',
  phone: '1234567890',
  zipcode: '53240',
  promoCode: '',
  office: null,
  prioridad_cliente: null,
  paso_del_proceso_del_cliente: null,
} : {
  name: '',
  email: '',
  phone: '',
  zipcode: '',
  promoCode: '',
  office: null,
  prioridad_cliente: null,
  paso_del_proceso_del_cliente: null,

}

export const defaultSellYourCarDocsForm = process.env.NODE_ENV === 'development' ? {
  theftReport: 'No',
  recovered: 'No',
  invoices: 'Sí, es 1 factura',
  registration: 'Si',
} : {
  theftReport: '',
  recovered: '',
  invoices: '',
  registration: '',
}

export const defaultScheduleForm = process.env.NODE_ENV === 'development' ? {
  day: '',
  time: '',
  office: '',
  zipcode: '',
  street: 'calle',
  exteriorNumber: '123',
  interiorNumber: '321',
} : {
  day: '',
  time: '',
  office: '',
  zipcode: '',
  street: '',
  exteriorNumber: '',
  interiorNumber: '',
}

export const defaultCheckoutPersonalInformationForm = process.env.NODE_ENV === 'development' ? {
  name: ' Sell Your Car Test',
  email: 'test@sell-your-car.com',
  phone: '1234567890',
} : {
  name: '',
  email: '',
  phone: '',
}

export const defaultLoginForm = process.env.NODE_ENV === 'development' ? {
  first_name: ' Sell Your',
  last_name: 'Car Test',
  phone: '1234567890',
} : {
  first_name: '',
  last_name: '',
  phone: '',
}
